<script>
	import UIIcon from "./UIIcon.svelte";
	import view from "../stores/view";
</script>

<a
	class="UITop"
	class:_visible={$view.scrollY > 80}
	href={"/"}
	on:click|preventDefault={() => view.scroll()}
>
	<UIIcon type="up" size={30} />
</a>

<style global>
	.UITop {
		display: block;
		width: 56px;
		height: 56px;
		border-radius: 50%;
		position: fixed;
		background: #ccc;
		right: 2em;
		bottom: 2em;
		z-index: 4;
		padding: 13px;
		transform: translateY(120px);
		transition: transform 300ms ease;
	}
	:global(.sp) .UITop {
		right: 8px;
		bottom: 60px;
	}

	.UITop._visible {
		transform: translateX(0);
	}
</style>
